{
  "nl": {
    "issue_list": {
      "actions": {
        "add_units": "Units",
        "change_responsible": "Verander verantwoordelijke",
        "check": "Controleren",
        "create_issue_lists": "Maak puntenlijst | Maak puntenlijsten",
        "delete": "Verwijder",
        "delete_count": "Je staat op het punt om punten voor {count} unit te verwijderen. Ben je zeker? | Je staat op het punt om punten voor {count} units te verwijderen. Ben je zeker?",
        "delete_issue_lists": "Verwijderen punten",
        "edit": "Bewerken",
        "edit_issue_list": "Bewerk puntenlijst",
        "export": "Exporteer",
        "generatePDF": "PDF genereren",
        "go_to_summary": "Ga naar samenvatting",
        "new": "Punt",
        "new_customer": "Meld defect",
        "new_issue_list": "Puntenlijst",
        "selectAll": "Selecteer alle {total} lijsten",
        "unSelectAll": "Wis selectie",
        "update": "Update"
      },
      "attributes": {
        "date": "Startdatum",
        "description": "Omschrijving",
        "name": "Naam"
      },
      "labels": {
        "aftercare_conversations": "Nazorg gesprekken",
        "aftercare_conversations_go_to_settings": "Ga naar instellingen",
        "aftercare_conversations_not_enabled": "Gesprekken binnen de nazorg zijn nog niet ingeschakeld. U kunt dit inschakelen in uw organisatie-instellingen.",
        "aftercare_conversations_toggle": "Gesprekken binnen de nazorg mogelijk maken",
        "assign_to_list": "Toewijzen aan lijst",
        "collapse_all": "Samenvouwen",
        "completed_header": "{completed_count} van {issues_count} punten voltooid",
        "customer": "Klant",
        "date": "Startdatum (optioneel)",
        "delete_explanation": "Alle punten samen met hun afbeeldingen en documenten zullen permament van het platform verwijderd worden.",
        "description_title": "Voeg een beschrijving toe",
        "deselect_all": "Alles deselecteren",
        "edit_multiple": "Bewerk {count} probleemlijsten",
        "hide_count": "Verberg punten voor 1 unit | Verberg punten voor {count} units",
        "hide_count_SUP": "Verberg punten",
        "issue_list": "Puntenlijst",
        "issue_lists": "Puntenlijsten",
        "issue_lists_all_projects": "Nazorg alle projecten",
        "issues_count": "Punten",
        "no_issues_to_export": "Geen punten om te exporteren",
        "no_lists_completed": "Geen punten voltooid",
        "open_all": "Openen",
        "partners": "Partners",
        "pdf_generated_successfully": "PDF succesvol gegenereerd",
        "process_issues": "Wijs punt toe | Wijs punten toe",
        "project_units_total": "{project_name} heeft {units_count_max} units in totaal",
        "publish_now": "Nu publiceren?",
        "published_count": "Publiceer punten voor 1 unit | Publiceer punten voor {count} units",
        "published_count_SUP": "Publiceer punten",
        "save_explainer": "Maak de (toekomstige) punten zichtbaar voor klanten? Of opslaan en later publiceren?",
        "selectOne": "Selecteer minimaal 1 lijst",
        "select_all": "Alles selecteren",
        "selected": "{selected} lijst geselecteerd. | {selected} lijsten geselecteerd",
        "status": "status",
        "step_1_info": "Bv, voorlopige of finale oplevering, punten in de keuken of badkamer,...",
        "step_1_title": "Welk type puntenlijst wil je maken?",
        "step_2_subtitle": "Selecteer het project om alle units toe te voegen. Je kan later steeds meer units toevoegen.",
        "step_2_title": "Voor welke units wil je punten loggen?",
        "tab_issue_list_documents": "Documenten",
        "tab_issue_list_issues": "Punten",
        "tab_issue_list_issues_customer": "Nazorg",
        "tab_issue_list_tickets": "Gesprekken",
        "tab_issues": "Alle punten",
        "tab_units": "Units",
        "totalSelected": "Alle {total} lijsten zijn geselecteerd",
        "you_have_customer_issues": "Je hebt 1 onverwerkt punt | Je hebt {number} onverwerkte punten van klanten"
      },
      "navigation": {
        "back_to_issue_lists": "Terug naar puntenlijsten"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Deze pagina is de follow-up van gemelde punten",
            "title": "Al jouw punten worden hier weergegeven"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Log punten voor units in deze lijst.",
            "title": "Maak je eerste puntenlijst"
          }
        },
        "partners": {
          "subtitle": "Je krijgt een melding wanneer er nieuwe punten zijn aangemaakt",
          "title": "Er zijn nog geen punten aan jou toegewezen"
        }
      },
      "validation": {
        "name_taken_locale": "Deze naam is al in gebruik in deze taal",
        "need_name": "Naam is verplicht"
      }
    }
  }
}
